import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { common } from '../common';

import { darkSeeMoreButton } from './helpers/dark-see-more-button';
import { hideGenderIcon } from './helpers/hide-gender-icon';
import { squarePanelListProviderRemovePrefixTransformer } from './helpers/square-panel-list-provider-remove-prefix-transformer';

export const squarePanelFromList = mergeMultipleConfigs(
  common.squarePanelFromList,
  [
    squarePanelListProviderRemovePrefixTransformer,
    hideGenderIcon,
    darkSeeMoreButton,
  ],
);
